// src/supabaseClient.js
import { createBrowserClient } from '@supabase/ssr';

// Load Supabase environment variables
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Use createBrowserClient for a more robust initialization
export const supabase = createBrowserClient(supabaseUrl, supabaseAnonKey);